import React from 'react';
import styles from './styles.module.scss';

const ConfirmModal = ({
  title,
  itemTitle,
  nestedCount = 0,
  onConfirm,
  onCancel,
  confirmText = 'Удалить',
  cancelText = 'Отмена'
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  const getNestedText = (count) => {
    if (count === 0) return null;

    const lastDigit = count % 10;
    const lastTwoDigits = count % 100;

    let word;
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
      word = 'вложенных элементов';
    } else if (lastDigit === 1) {
      word = 'вложенный элемент';
    } else if (lastDigit >= 2 && lastDigit <= 4) {
      word = 'вложенных элемента';
    } else {
      word = 'вложенных элементов';
    }

    return `${count} ${word}`;
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.confirmModal}>
        <h3 className={styles.confirmTitle}>{title}</h3>

        <div className={styles.confirmContent}>
          <p className={styles.confirmItemName}>«{itemTitle}»</p>
          {nestedCount > 0 && (
            <p className={styles.confirmNested}>
              Содержит {getNestedText(nestedCount)}
            </p>
          )}
        </div>

        <p className={styles.confirmMessage}>
          {nestedCount > 0
            ? 'Элемент и все вложенные будут удалены безвозвратно.'
            : 'Элемент будет удалён безвозвратно.'}
        </p>

        <div className={styles.confirmActions}>
          <button
            type="button"
            className={styles.cancelButton}
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={styles.deleteButton}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
